import React from 'react';
export const CFIconBarChart = {
    alias: 'bar-chart',
    defaultTitle: 'Bar Chart',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M12 4c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1Zm7 8c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1v-7c0-.55-.45-1-1-1ZM4 9c0-.55.45-1 1-1s1 .45 1 1v11c0 .55-.45 1-1 1s-1-.45-1-1V9Z' }))),
};
